export * from './DrugsSearch';
export { default } from './DrugsSearch';
